import { useState } from 'react';
import Score from './Score';
import Level from './Level';
import Images from '../../../PointsProgram/hooks/Levels/Images';
import DeleteProfile from './DeleteProfile';

const Profile = (vm) => {
  const [open, setOpen] = useState(false);
  const [user, setUser]= useState(vm.userLogin)
  const [score, setScore] = useState('-')
  const [dateUpdate, setDateUpdate] = useState(null)
  const [closeActive, setCloseActive] = useState(true)
  const [loading, setLoading] = useState(false)
  const [loadingScore, setLoadingScore] = useState(true)
  const [loadingLevels, setLoadingLevels] = useState(true)

  Score({
    userId: user?.Id,
    logout: vm.logout,
    message: vm.message,
    setScore,
    setDateUpdate,
    setLoading: setLoadingScore
  })

  const lv = Level({
    score,
    setLoading: setLoadingLevels,
    logout: vm.logout,
    message: vm.message
  })

  const updateUser = (us) => {
    setUser(us)
    vm.onUser(us)
  }

  const validAction = async () => {
    const lostAccess = await vm.losesAccess?.();
    if (lostAccess) return;
    setOpen(true)
  }

  const deleteProfile = DeleteProfile({
    user,
    loading,
    logout: vm.logout,
    message: vm.message,
    onLogout: vm.onLogout,
    losesAccess: vm.losesAccess,
    setLoading
  })

  const getImage =  Images({
    losesAccess: vm.losesAccess,
    message: vm.message,
    logout: vm.logout
  })

  return {
    ...lv,
    ...deleteProfile,
    loading,
    loadingPoints: loadingScore || loadingLevels,
    score,
    user,
    dateUpdate,
    logout: vm.logout,
    open,
    losesAccess: vm.losesAccess,
    message: vm.message,
    closeActive,
    getImageUrl: getImage.getImageUrl,
    setCloseActive,
    setOpen,
    validAction,
    updateUser
  }
}

export default Profile;
